// import

import {styled} from 'goober';
import * as R from 'ramda';
import type {ComponentProps, PropsWithChildren} from 'react';

import type {UrlNode} from 'libs/model';

import {ShareLink} from './ShareLink';
import type {getLinkProps} from './getLinkProps';

// types

type Props = ComponentProps<typeof Styled> & PropsWithChildren<{
  meta: UrlNode['meta'];
  services: Array<keyof typeof getLinkProps>;
}>;

// component

export function ShareLinks(props: Props) {
  const {children, meta, services, ...rest} = props;

  return (
    <Styled {...rest}>
      {R.uniq(services).map((service) => (
        <ShareLink key={service} meta={meta} service={service} />
      ))}

      {children}
    </Styled>
  );
}

// styles

export const Styled = styled('aside')`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  gap: 0.5rem;
`;
